<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="toc">
<h1 class="toc_title"><a id="page5"></a>CONTENTS</h1>
<p class="toc_fmbm"><a class="hlink" href="#/Text/9781618372475_fwd"><span class="tsplb">FOREWORD</span></a></p>
<p class="toc_fmbm"><a class="hlink" href="#/Text/9781618372475_itr"><span class="tsplb">INTRODUCTION</span></a></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781618372475_c01" title="Link target outside of Sample"><span class="tspl"><strong>Jams &amp; Preserves</strong></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781618372475_c02" title="Link target outside of Sample"><span class="tspl"><strong>Fruit Butters &amp; Jellies</strong></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781618372475_c03" title="Link target outside of Sample"><span class="tspl"><strong>Compotes, Chutneys &amp; Marmalades</strong></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781618372475_c04" title="Link target outside of Sample"><span class="tspl"><strong>Pickles &amp; Relishes</strong></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781618372475_c05" title="Link target outside of Sample"><span class="tspl"><strong>Pickled Fruits &amp; Vegetables</strong></span></span></p>
<p class="toc_fmbm"><span class="hlink" href="#/Text/9781618372475_crd" title="Link target outside of Sample"><span class="tsplb">PHOTOGRAPHY CREDITS</span></span></p>
<p class="toc_fmbm"><span class="hlink" href="#/Text/9781618372475_bm1" title="Link target outside of Sample"><span class="tsplb">METRIC CONVERSION CHARTS</span></span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781618372475_toc.vue?69798be4